/**
 * Incidents the user has opened in this browser. The sidebar badge counts
 * only open incidents not yet seen, so opening one lowers the count.
 */
import { useSyncExternalStore } from 'react';

const KEY = 'ensomirai.seenIncidents';
const listeners = new Set<() => void>();

function load(): Set<string> {
  try {
    const raw = localStorage.getItem(KEY);
    return new Set(raw ? (JSON.parse(raw) as string[]) : []);
  } catch {
    return new Set();
  }
}

let seen = load();

export function markIncidentSeen(id: string | null | undefined) {
  if (!id || seen.has(id)) return;
  seen = new Set(seen).add(id);
  try {
    localStorage.setItem(KEY, JSON.stringify([...seen]));
  } catch {
    /* per-browser convenience only */
  }
  listeners.forEach((l) => l());
}

const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => listeners.delete(l);
};

export const useSeenIncidents = () => useSyncExternalStore(subscribe, () => seen);
